import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {SessionService} from '../Services/Session/session-service.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-important-phones',
  templateUrl: './important-phones.component.html',
  styleUrls: ['./important-phones.component.css',  '../../assets/layout/style/layout.css']
})
export class ImportantPhonesComponent implements OnInit {
  importantPhones: any[] = [];
  importantPhonesUpdated: any[] = [];
  country:any = 502;
  env = environment;

  constructor(private api: ApiService, private st: SessionService, private realm: RealmService) { }

  ngOnInit(): void {
    this.st.getData('user').then( (data: any) => {
      this.country = data.phoneArea;
    });
    this.realm.getImportantPhones(this.country);
    this.realm.importantPhones$.subscribe( (data: any) => {
      console.log("data important phones: ", data);
      this.importantPhones = JSON.parse(JSON.stringify(data.importantPhones));
      if (this.env.policyHolderCardNumberOld.indexOf('U') > -1) {
        this.importantPhonesUpdated = this.importantPhones.map(obj => {
          if (obj.title == 'Tecniseguros') {
            return { ...obj, title: 'Emergencia', desc: '23006655'}
          }
          return obj;
        })
      } else {
        this.importantPhonesUpdated = this.importantPhones;
      }
    });
    console.log("updated: "+ this.importantPhonesUpdated);
  }

}
